import React, {Component} from 'react';
import Navigation from "../../../shared/Navigation";
import {TabScreen} from "../../dumb";
import AccountsDashboard from "./AccountsDashboard";
import Settings from './Settings';
import Listings from './Listings';
import POSOverview from './POSOverview';

const BASE_URL = '/accountsoverview';

const subpages = [{
    "label": "Accounts Dashboard",
    "url": "/dashboard",
    "component": <AccountsDashboard/>
},
{
    "label": "Settings",
    "url": "/settings",
    "component": <Settings/>
},
{
    "label": "Listings",
    "url": "/listings",
    "component": <Listings/>
},
{
    "label": "POS Overview",
    "url": "/pos",
    "component": <POSOverview/>
}];

class AccountsOverview extends Component {
    render() {
       return <TabScreen subpages={subpages} BASE_URL={BASE_URL} Navigation={Navigation}></TabScreen>
    }
}

export default AccountsOverview;
